<section class="app-counter">
  <div class="container app-counter__con">
    <img
      ngSrc="assets/images/counter/counter-ornament-1.webp"
      alt="reward ornaments"
      width="222"
      height="253"
      priority="false"
      class="app-counter__con--ornament-1"
      [appAnimate]="'fadeIn'"
      [speed]="'fast'"
      [aos]="0.2"
      [once]="true"
      [delay]="'100'"
    />

    <img
      ngSrc="assets/images/counter/counter-ornament-2.webp"
      alt="reward ornaments"
      width="210"
      height="243"
      priority="false"
      class="app-counter__con--ornament-2"
      [appAnimate]="'fadeIn'"
      [speed]="'fast'"
      [aos]="0.2"
      [once]="true"
      [delay]="'100'"
    />

    <h2
      [appAnimate]="'landing'"
      [speed]="'fast'"
      [aos]="0.2"
      [once]="true"
      [delay]="'100'"
      class="app-counter__con--h2 app-title text-center navy-blue"
    >
      Do końca Loterii zostało:
    </h2>

    <div class="app-counter__con__wr">
      @if (difference !== null) {
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="419.144"
          height="133.332"
          viewBox="0 0 419.144 133.332"
          [appAnimate]="'landing'"
          [speed]="'fast'"
          [aos]="0.2"
          [once]="true"
          [delay]="'100'"
          class="app-counter__con__svg"
        >
          <defs>
            <clipPath id="a">
              <rect width="419.144" height="133.332" fill="none" />
            </clipPath>
            <clipPath id="d">
              <rect
                width="61.138"
                height="45.984"
                transform="translate(13 58.983)"
                fill="none"
              />
            </clipPath>
            <clipPath id="e">
              <rect
                width="61.139"
                height="45.984"
                transform="translate(76.772 58.983)"
                fill="none"
              />
            </clipPath>
            <clipPath id="f">
              <rect
                width="61.138"
                height="45.984"
                transform="translate(146.844 58.983)"
                fill="none"
              />
            </clipPath>
            <clipPath id="g">
              <rect
                width="61.138"
                height="45.984"
                transform="translate(210.616 58.983)"
                fill="none"
              />
            </clipPath>
            <clipPath id="h">
              <rect
                width="61.139"
                height="45.984"
                transform="translate(281.233 58.983)"
                fill="none"
              />
            </clipPath>
            <clipPath id="i">
              <rect
                width="61.138"
                height="45.984"
                transform="translate(345.006 58.983)"
                fill="none"
              />
            </clipPath>
          </defs>
          <g clip-path="url(#a)">
            <g clip-path="url(#a)">
              <path
                d="M411.178,0H7.967A8.1,8.1,0,0,0,0,8.219V117.431a8.1,8.1,0,0,0,7.967,8.219H411.178a8.1,8.1,0,0,0,7.966-8.219V8.219A8.1,8.1,0,0,0,411.178,0"
                fill="#fff"
              />
              <path
                d="M19.333,125.65v5.473a2.209,2.209,0,0,0,2.209,2.209H53.124a2.209,2.209,0,0,0,2.209-2.209V125.65Z"
                fill="#424242"
              />
              <path d="M19.333,125.649v5.473l36-5.473Z" fill="#1a1a1a" />
              <path
                d="M367.681,125.65v5.473a2.209,2.209,0,0,0,2.209,2.209h31.582a2.209,2.209,0,0,0,2.209-2.209V125.65Z"
                fill="#424242"
              />
              <path d="M367.681,125.649v5.473l36-5.473Z" fill="#1a1a1a" />
              <path
                d="M69.662,13H17.476A4.476,4.476,0,0,0,13,17.476v83.015a4.476,4.476,0,0,0,4.476,4.476H69.662a4.476,4.476,0,0,0,4.476-4.476V17.476A4.476,4.476,0,0,0,69.662,13"
                fill="#373737"
              />
              <path
                d="M14.922,55.942a.542.542,0,0,0-.542.541v5a.542.542,0,0,0,1.083,0v-5a.541.541,0,0,0-.541-.541"
                fill="#757575"
              />
              <path
                d="M72.217,62.024a.541.541,0,0,0,.541-.541v-5a.541.541,0,0,0-1.082,0v5a.541.541,0,0,0,.541.541"
                fill="#757575"
              />
              <path
                d="M133.434,13H81.248a4.476,4.476,0,0,0-4.476,4.476v83.015a4.476,4.476,0,0,0,4.476,4.476h52.186a4.476,4.476,0,0,0,4.476-4.476V17.476A4.476,4.476,0,0,0,133.434,13"
                fill="#373737"
              />
              <path
                d="M78.694,55.942a.541.541,0,0,0-.541.541v5a.541.541,0,0,0,1.082,0v-5a.541.541,0,0,0-.541-.541"
                fill="#757575"
              />
              <path
                d="M135.989,62.024a.541.541,0,0,0,.541-.541v-5a.541.541,0,0,0-1.082,0v5a.541.541,0,0,0,.541.541"
                fill="#757575"
              />
              <path
                d="M203.505,13H151.319a4.476,4.476,0,0,0-4.476,4.476v83.015a4.476,4.476,0,0,0,4.476,4.476h52.186a4.476,4.476,0,0,0,4.476-4.476V17.476A4.476,4.476,0,0,0,203.505,13"
                fill="#373737"
              />
              <path
                d="M148.765,55.942a.541.541,0,0,0-.541.541v5a.541.541,0,0,0,1.082,0v-5a.541.541,0,0,0-.541-.541"
                fill="#757575"
              />
              <path
                d="M206.06,62.024a.541.541,0,0,0,.541-.541v-5a.541.541,0,1,0-1.082,0v5a.541.541,0,0,0,.541.541"
                fill="#757575"
              />
              <path
                d="M267.277,13H215.091a4.476,4.476,0,0,0-4.476,4.476v83.015a4.476,4.476,0,0,0,4.476,4.476h52.186a4.477,4.477,0,0,0,4.477-4.476V17.476A4.477,4.477,0,0,0,267.277,13"
                fill="#373737"
              />
              <path
                d="M212.537,55.942a.541.541,0,0,0-.541.541v5a.541.541,0,0,0,1.082,0v-5a.541.541,0,0,0-.541-.541"
                fill="#757575"
              />
              <path
                d="M269.832,62.024a.541.541,0,0,0,.541-.541v-5a.541.541,0,1,0-1.082,0v5a.541.541,0,0,0,.541.541"
                fill="#757575"
              />
              <path
                d="M337.895,13H285.709a4.476,4.476,0,0,0-4.476,4.476v83.015a4.476,4.476,0,0,0,4.476,4.476h52.186a4.476,4.476,0,0,0,4.476-4.476V17.476A4.476,4.476,0,0,0,337.895,13"
                fill="#373737"
              />
              <path
                d="M283.154,55.942a.541.541,0,0,0-.541.541v5a.541.541,0,0,0,1.082,0v-5a.541.541,0,0,0-.541-.541"
                fill="#757575"
              />
              <path
                d="M340.45,62.024a.541.541,0,0,0,.541-.541v-5a.541.541,0,1,0-1.082,0v5a.541.541,0,0,0,.541.541"
                fill="#757575"
              />
              <path
                d="M401.667,13H349.481a4.476,4.476,0,0,0-4.476,4.476v83.015a4.476,4.476,0,0,0,4.476,4.476h52.186a4.476,4.476,0,0,0,4.476-4.476V17.476A4.476,4.476,0,0,0,401.667,13"
                fill="#373737"
              />
              <path
                d="M346.926,55.942a.541.541,0,0,0-.541.541v5a.541.541,0,0,0,1.082,0v-5a.541.541,0,0,0-.541-.541"
                fill="#757575"
              />
              <path
                d="M404.222,62.024a.541.541,0,0,0,.541-.541v-5a.541.541,0,1,0-1.082,0v5a.541.541,0,0,0,.541.541"
                fill="#757575"
              />
            </g>
            <g clip-path="url(#a)">
              <g style="mix-blend-mode: soft-light; isolation: isolate">
                <g clip-path="url(#d)">
                  <path
                    d="M13,58.983V100.49a4.477,4.477,0,0,0,4.476,4.477H69.662a4.478,4.478,0,0,0,4.477-4.477V58.983Z"
                    fill="#373737"
                  />
                </g>
              </g>
              <g style="mix-blend-mode: soft-light; isolation: isolate">
                <g clip-path="url(#e)">
                  <path
                    d="M76.772,58.983V100.49a4.477,4.477,0,0,0,4.476,4.477h52.186a4.478,4.478,0,0,0,4.477-4.477V58.983Z"
                    fill="#373737"
                  />
                </g>
              </g>
              <g style="mix-blend-mode: soft-light; isolation: isolate">
                <g clip-path="url(#f)">
                  <path
                    d="M146.844,58.983V100.49a4.477,4.477,0,0,0,4.476,4.477h52.186a4.478,4.478,0,0,0,4.477-4.477V58.983Z"
                    fill="#373737"
                  />
                </g>
              </g>
              <g style="mix-blend-mode: soft-light; isolation: isolate">
                <g clip-path="url(#g)">
                  <path
                    d="M210.616,58.983V100.49a4.477,4.477,0,0,0,4.476,4.477h52.186a4.478,4.478,0,0,0,4.477-4.477V58.983Z"
                    fill="#373737"
                  />
                </g>
              </g>
              <g style="mix-blend-mode: soft-light; isolation: isolate">
                <g clip-path="url(#h)">
                  <path
                    d="M281.233,58.983V100.49a4.477,4.477,0,0,0,4.476,4.477h52.186a4.478,4.478,0,0,0,4.477-4.477V58.983Z"
                    fill="#373737"
                  />
                </g>
              </g>
              <g style="mix-blend-mode: soft-light; isolation: isolate">
                <g clip-path="url(#i)">
                  <path
                    d="M345.006,58.983V100.49a4.477,4.477,0,0,0,4.476,4.477h52.186a4.478,4.478,0,0,0,4.477-4.477V58.983Z"
                    fill="#373737"
                  />
                </g>
              </g>
            </g>

            <text
              transform="translate(29.396 82.998)"
              fill="#fff"
              font-size="71.583"
              font-family="BebasNeueBold, Bebas Neue"
            >
              <tspan x="0" y="0">{{ days() | firstChar }}</tspan>
            </text>
            <text
              transform="translate(93.177 82.998)"
              fill="#fff"
              font-size="71.583"
              font-family="BebasNeueBold, Bebas Neue"
            >
              <tspan x="0" y="0">{{ days() | secondChar }}</tspan>
            </text>
            <text
              transform="translate(163.256 82.998)"
              fill="#fff"
              font-size="71.583"
              font-family="BebasNeueBold, Bebas Neue"
            >
              <tspan x="0" y="0">{{ hours() | firstChar }}</tspan>
            </text>
            <text
              transform="translate(227.037 82.998)"
              fill="#fff"
              font-size="71.583"
              font-family="BebasNeueBold, Bebas Neue"
            >
              <tspan x="0" y="0">{{ hours() | secondChar }}</tspan>
            </text>
            <text
              transform="translate(297.618 82.998)"
              fill="#fff"
              font-size="71.583"
              font-family="BebasNeueBold, Bebas Neue"
            >
              <tspan x="0" y="0">{{ minutes() | firstChar }}</tspan>
            </text>
            <text
              transform="translate(361.398 82.998)"
              fill="#fff"
              font-size="71.583"
              font-family="BebasNeueBold, Bebas Neue"
            >
              <tspan x="0" y="0">{{ minutes() | secondChar }}</tspan>
            </text>
            <text transform="translate(67 117.163)" font-size="12">
              <tspan x="0" y="0">
                {{
                  days()
                    | polishPlural
                      : dayPolishPlural[0]
                      : dayPolishPlural[1]
                      : dayPolishPlural[2]
                }}
              </tspan>
            </text>
            <text transform="translate(195 117.163)" font-size="12">
              {{
                hours()
                  | polishPlural
                    : hourPolishPlural[0]
                    : hourPolishPlural[1]
                    : hourPolishPlural[2]
              }}
            </text>
            <text transform="translate(330 117.163)" font-size="12">
              {{
                minutes()
                  | polishPlural
                    : minutePolishPlural[0]
                    : minutePolishPlural[1]
                    : minutePolishPlural[2]
              }}
            </text>
          </g>
        </svg>

        <!--        <ul class="app-counter__con__wr__tim list-unstyled">-->
        <!--          <li>-->
        <!--            <span> {{ days() }}</span>-->
        <!--            <small-->
        <!--              >{{-->
        <!--                days()-->
        <!--                  | polishPlural-->
        <!--                    : dayPolishPlural[0]-->
        <!--                    : dayPolishPlural[1]-->
        <!--                    : dayPolishPlural[2]-->
        <!--              }}-->
        <!--            </small>-->
        <!--          </li>-->
        <!--          <li>-->
        <!--            <span> {{ hours() }}</span>-->
        <!--            <small>{{-->
        <!--              hours()-->
        <!--                | polishPlural-->
        <!--                  : hourPolishPlural[0]-->
        <!--                  : hourPolishPlural[1]-->
        <!--                  : hourPolishPlural[2]-->
        <!--            }}</small>-->
        <!--          </li>-->
        <!--          <li>-->
        <!--            <span>{{ minutes() }}</span>-->
        <!--            <small>{{-->
        <!--              minutes()-->
        <!--                | polishPlural-->
        <!--                  : minutePolishPlural[0]-->
        <!--                  : minutePolishPlural[1]-->
        <!--                  : minutePolishPlural[2]-->
        <!--            }}</small>-->
        <!--          </li>-->
        <!--        </ul>-->
      }
    </div>
  </div>
</section>
